import { mapGetters } from 'vuex'
import Misc from 'src/utils/helper/misc'

export default {
  ...mapGetters('binaries', {
    binaries: ['list']
  }),
  ...mapGetters('submissions', ['selectedRelatedFamilies']),
  ...mapGetters('profile', {'foundries': ['foundries']}),
  packages () {
    let packs = this.submission.userMetaData?.packages || []
    /**
     * Add filename to each style in each pack
     */
    for (const pack of packs) {
      for (const style of pack.styles) {
        style.fileName = this.getBinaryFileName(style.binaryId)
      }
    }
    return packs
  },
  showCustomerMsgLabel() {
    const msg = this.submission.userMetaData?.customerMessage || ''
    return msg.length > 0
  },
  customerMsg() {
    const msg = this.submission.userMetaData?.customerMessage || ''
    return msg.length > 0 ? msg : ''
  },
  designers() {
    const designers = this.submission.userMetaData?.designers || []
    return designers.length > 0 ? designers.map(d => d.name).join(', ') : ''
  },
  familyPackage() {
    const familyPackage = this.packages.filter(
      p => p.packageType === 'familyPackage'
    )[0]
    return typeof familyPackage === 'object' ? familyPackage : {}
  },
  customFamilyPackageSingleStyle() {
    const customFamilyPacks =
    this.submission.userMetaData?.packages || []
    const styleValue = Misc.dashedString(
      customFamilyPacks[0].styles[0].binaryName
    )
    return styleValue
  },
  singleStyles() {
    const packages = Object.assign(
      [],
      this.packages.filter(p => p.packageType === 'singleStyle')
    )
    for (const packageItem of packages) {
      packageItem.styles[0].styleURL = Misc.dashedString(packageItem.styles[0].binaryName);
    }
    return packages
  },
  customPackages() {
    return this.packages.filter(p => p.packageType === 'customPackage')
  },
  familyDescriptions() {
    // Add removed html breaks from sanitizer for preview page output
    return this.submissionFamilyDescriptions
      ? this.submissionFamilyDescriptions.map(d => ({
          language: d.language,
          description: d.description.replace(/\r|\n|\r\n/g, '<br />')
        }))
      : []
  },
  carouselImages() {
    return this.submissionImageSortorders[0].imageIds
  },
  relatedFamiliesGroupName () {
    const lastSelected = this.selectedRelatedFamilies?.[0]
    return lastSelected?.familyName || ''
  },
  relatedFamiliesCount () {
    return (this.selectedRelatedFamilies?.length) ? this.selectedRelatedFamilies.length - 1 : 0
  },
  maxFamiliesCount () {
    return (this.selectedRelatedFamilies?.length) ? this.selectedRelatedFamilies.length - 1 : 0
  },
  getSelectedFoundry () {
    let foundryDetails = {}
    if (this.foundryDetails?.contractSummary) {
      foundryDetails = this.foundryDetails
    } else {
      foundryDetails = this.foundries.find(response => this.submission.foundry.name === response.name)
    }
    return foundryDetails
  }
}
